import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - yy漫画网韩漫免费在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          {comic.isHot && (
            <span className="inline-block px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="inline-block px-2 py-0.5 text-xs font-medium rounded-full bg-accent-500 text-background-50 ml-1 whitespace-nowrap">
              新作
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="inline-block px-2 py-0.5 text-xs font-medium rounded-full bg-background-950/60 text-background-50 whitespace-nowrap">
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-3">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-500"></i>
            <span>{comic.rating}</span>
            <span className="mx-1">·</span>
            <i className="ri-eye-line"></i>
            <span>{comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1">{comic.author}</p>
        <div className="flex items-center gap-1 mt-2">
          <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
            {comic.category}
          </span>
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="inline-block px-2 py-0.5 text-xs rounded-full bg-background-100 text-foreground-500 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}